module.exports = __webpack_public_path__ + "static/media/arrow_right.97cd4b05.svg";